module.exports = __webpack_public_path__ + "img/clonetest.57848105.svg";